// A simple pure functional component used to circumvent the fact
// that 'v-slot' directive must be owned by a custom element

export default {
  name: "SlotWrapper",
  render() {
    const slotNames = Object.keys(this.$slots);
    return slotNames.length ? this.$slots[slotNames[0]]() : null;
  }
};
